export const MENSAGEM_ERRO_RESPOSTA_GENERICA =
  'Não foi possível enviar sua resposta. Tente novamente.';

export class PortalApiError extends Error {
  readonly status: number;
  readonly apiMessage: string | null;

  constructor(status: number, apiMessage?: string | null) {
    const mensagem = apiMessage?.trim() || MENSAGEM_ERRO_RESPOSTA_GENERICA;
    super(mensagem);
    this.name = 'PortalApiError';
    this.status = status;
    this.apiMessage = apiMessage?.trim() || null;
  }
}

export function mensagemDeErroApi(payload: unknown): string | null {
  if (typeof payload !== 'object' || payload === null || !('error' in payload)) return null;

  const error = payload.error;
  if (typeof error !== 'object' || error === null || !('message' in error)) return null;

  return typeof error.message === 'string' && error.message.trim().length > 0
    ? error.message
    : null;
}

/** 408 e 429 são 4xx, mas não dizem nada sobre o token: o pedido nem chegou a ser avaliado. */
const STATUS_4XX_TRANSITORIOS = new Set([408, 429]);

/**
 * Link usado ou vencido chega como 4xx. Sem status (rede caída), 5xx, 408 e 429 são transitórios:
 * tratar como link morto mandaria a pessoa pedir outro e invalidar à toa o que ela tem em mãos.
 */
export function ehLinkDeAcessoInvalido(error: unknown): boolean {
  if (!(error instanceof PortalApiError)) return false;
  return error.status >= 400 && error.status < 500 && !STATUS_4XX_TRANSITORIOS.has(error.status);
}

export function mensagemSeguraPortal(error: unknown): string {
  if (
    error instanceof PortalApiError &&
    error.status >= 400 &&
    error.status < 500 &&
    error.apiMessage
  ) {
    return error.apiMessage;
  }

  return MENSAGEM_ERRO_RESPOSTA_GENERICA;
}
